import { create } from 'zustand';

import { SchoolSettingsRepository } from '../../api/repository/school-settings';
import type { QltSchoolSettings } from '../../api/types';
import { userErrorMessage } from '../userError';

export interface QltSchoolSettingsState {
  settings: QltSchoolSettings | null;
  loading: boolean;
  error: string | null;
  load: () => Promise<QltSchoolSettings | null>;
}

export const useQltSchoolSettingsStore = create<QltSchoolSettingsState>((set) => ({
  settings: null,
  loading: false,
  error: null,
  async load() {
    set({ loading: true, error: null });
    try {
      const settings = await SchoolSettingsRepository.fetch();
      set({ settings, loading: false });
      return settings;
    } catch (error) {
      set({ loading: false, error: userErrorMessage(error) });
      return null;
    }
  },
}));
